import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITaxpayerCategoryState, ITaxpayerCategoryDropdown } from "../../../types/taxpayerCategories/taxpayerCategoryInterfaces";

export const initialState: ITaxpayerCategoryState = {
  taxpayerCategoryDropdown: []
};

export const taxpayerCategorySlice = createSlice({
  name: 'taxpayerCategory',
  initialState,
  reducers: {
    loadingTaxpayerCategoryDropdown: (state, action: PayloadAction<ITaxpayerCategoryDropdown[]>) => {
      state.taxpayerCategoryDropdown = action.payload;
    },
  }
});

export const { loadingTaxpayerCategoryDropdown } = taxpayerCategorySlice.actions;

export default taxpayerCategorySlice.reducer;
